/**
 * Default fallback menu structure
 * Used when menu data is loading or unavailable from CMS
 */
export const FALLBACK_MENU = {
  logo: null,
  items: [
    {
      label: "Home",
      url: "/",
      external_link: false,
      sub_items: [],
    },
    {
      label: "Frames",
      url: "/frames",
      external_link: false,
      sub_items: [],
    },
    {
      label: "Sunglasses",
      url: "/sunglasses",
      external_link: false,
      sub_items: [],
    },
    {
      label: "Accessories",
      url: "/accessories",
      external_link: false,
      sub_items: [],
    },
    {
      label: "Blog",
      url: "/blog",
      external_link: false,
      sub_items: [],
    },
    {
      label: "About",
      url: "/about",
      external_link: false,
      sub_items: [
        {
          label: "Contact",
          url: "/contact",
          external_link: false,
        },
        {
          label: "FAQ",
          url: "/faq",
          external_link: false,
        },
        {
          label: "Privacy Policy",
          url: "/privacy-policy",
          external_link: false,
        },
        {
          label: "Terms & Conditions",
          url: "/terms-and-conditions",
          external_link: false,
        },
      ],
    },
  ],
};

/**
 * Menu styling constants
 */
export const MENU_STYLES = {
  menuList: {
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    width: "100%",
    margin: 0,
    padding: 0,
  },
  menuItem: {
    flex: "1 1 auto",
    textAlign: "center",
    padding: "0 5px",
    minWidth: "fit-content",
    position: "relative",
  },
  submenu: {
    background: "#000000ff",
    left: "0",
    transform: "none",
    minWidth: "max-content",
    padding: "8px 0",
    border: "1px solid #2c2c2cff",
  },
  submenuLink: {
    color: "#ffffff",
    padding: "6px 12px",
    display: "block",
    whiteSpace: "nowrap",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "1.4",
    transition: "color 0.1s ease",
  },
};
